import { AiHubSamplePage } from '../Components/AiHubSamplePage/AiHubSamplePage';
import { AssistPage } from '../Components/AssistPage/AssistPage';
import { AppHostedAutomatePage } from '../Components/AutomatePage/AutomatePage';
import { BizChatNativePage } from '../Components/BizChatNativePage/BizChatNativePage';
import { BrowsePage } from '../Components/BrowsePage/BrowsePage';
import { CatchUpPage } from '../Components/CatchUpPage/CatchUpPage';
import { CollectPage } from '../Components/CollectPage/CollectPage';
import { CreatePageV2 } from '../Components/CreatePage/CreatePageV2';
import { NewsPage } from '../Components/NewsPage/NewsPage';
import { PeoplePage } from '../Components/People/PeoplePage';
import { PreparePage } from '../Components/PreparePage/PreparePage';
import { WorkplacePage } from '../Components/WorkplacePage/WorkplacePage';
var appRoutes = [];
export function getAppHostedRoutes(prefix) {
    if (prefix === void 0) { prefix = ''; }
    if (!appRoutes.length) {
        appRoutes = [
            {
                route: {
                    path: prefix + "/aiHubSample/" /* RoutePaths.AiHubSample */,
                    component: AiHubSamplePage,
                },
            },
            {
                route: {
                    path: prefix + "/catchup/" /* RoutePaths.CatchUp */,
                    component: CatchUpPage,
                },
            },
            {
                route: {
                    path: prefix + "/collect/" /* RoutePaths.Collect */,
                    component: CollectPage,
                },
            },
            {
                route: {
                    path: prefix + "/prepare/" /* RoutePaths.Prepare */,
                    component: PreparePage,
                },
            },
            {
                route: {
                    path: prefix + "/workplace/" /* RoutePaths.Workplace */,
                    component: WorkplacePage,
                },
            },
            {
                route: {
                    path: prefix + "/people/" /* RoutePaths.People */,
                    component: PeoplePage,
                },
            },
            {
                route: {
                    path: prefix + "/browse/" /* RoutePaths.Browse */,
                    component: BrowsePage,
                },
            },
            {
                route: {
                    path: prefix + "/assist/" /* RoutePaths.Assist */,
                    component: AssistPage,
                },
            },
            {
                route: {
                    path: prefix + "/actions/" /* RoutePaths.Actions */,
                    component: AppHostedAutomatePage,
                },
            },
            {
                route: {
                    path: prefix + "/bizchat/" /* RoutePaths.BizChatNative */,
                    component: BizChatNativePage,
                },
            },
            {
                route: {
                    path: prefix + "/create/:entityId?/:subEntityId?" /* RoutePaths.Create */,
                    component: CreatePageV2,
                },
            },
            {
                route: {
                    path: prefix + "/news/" /* RoutePaths.News */,
                    component: NewsPage,
                },
            },
        ];
    }
    return appRoutes;
}
//# sourceMappingURL=getAppHostedRoutes.js.map